import { computeVariant } from '@/shared/lib/abTest';

import type { TrialPaywallVariant } from './types';

import { TRIAL_PAYWALL_VARIANT_KEY } from './constants';

export const computeTrialPaywallVariant = (userId: string, country: null | string | undefined): TrialPaywallVariant =>
  computeVariant(TRIAL_PAYWALL_VARIANT_KEY, userId, country);
